import * as React from "react";
import { useCallback } from "react";
import { TableCell } from "@mzc-pdc/ui";
import { Grid } from "@mui/material";
import Skeleton from "@components_v2/skeleton/skeleton";

export const SkeletonLinkedAssetsCollectionTable = ({ columns }) => {
    const getSkeletonByColumn = useCallback(
        (column) => {
            const { id: columnId, style } = column;
            if (!columnId) return;
            if (columnId === "desiredStatus")
                return <Skeleton variant="rounded" animation={"wave"} width={32} height={18} />;
            if (columnId === "name")
                return (
                    <Grid
                        container
                        direction={`row`}
                        justifyContent={`flex-start`}
                        alignItems={`center`}
                        flexWrap={"nowrap"}
                        width={`calc(100% - 32px)`}
                    >
                        <Grid item>
                            <Skeleton variant="rounded" animation={"wave"} width={40} height={40} sx={{ mr: 1.5 }} />
                        </Grid>
                        <Grid item flex={1}>
                            <Skeleton variant="rounded" animation={"wave"} width={"100%"} height={21} />
                        </Grid>
                    </Grid>
                );
            if (columnId === "size")
                return (
                    <Grid container direction={`column`} justifyContent={`flex-start`} alignItems={`center`}>
                        <Grid item>
                            <Skeleton variant="rounded" animation={"wave"} width={80} height={18} />
                        </Grid>
                    </Grid>
                );
            if (columnId === "createdAt")
                return <Skeleton variant="rounded" animation={"wave"} width={250} height={18} />;
            return <Skeleton variant="rounded" animation={"wave"} width={style?.custom?.width ?? 100} height={18} />;
        },
        [columns],
    );

    return (
        <>
            <TableCell sx={{ width: "32px", ml: 1.5 }} padding="checkbox">
                <Skeleton variant="rounded" animation={"wave"} width={18} height={18} />
            </TableCell>
            {columns &&
                columns.map((column) => (
                    <TableCell
                        key={column.id}
                        mt={1}
                        mb={1}
                        sx={{
                            ...(column?.style?.custom ?? {}),
                            width: (column?.style?.custom?.width || column?.style?.custom?.minWidth) ?? undefined,
                        }}
                    >
                        {getSkeletonByColumn(column)}
                    </TableCell>
                ))}
            <TableCell sx={{ width: "50px" }} padding="checkbox">
                <Skeleton variant="circular" animation={"wave"} width={24} height={24} />
            </TableCell>
        </>
    );
};

export default SkeletonLinkedAssetsCollectionTable;
